<template>
  <div id="appRoot">
    <template v-if="$route.meta.frame">
      <v-app>
        <v-content class="content-wrapper">
          <Toolbar></Toolbar>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
        </v-content>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import AppEvents from './event'
import themes from '@/theme/themes'

/**
 * Vue super class
 * Introduces mock-toolbar (16px at the top) with the company ci colors
 * if <frame> keyword is set to true in router/paths.js
 */
export default {
  name: 'App',
  components: {
    Toolbar
  },
  data () {
    return {
      //
    }
  },
  methods : {
    /**
     * access Vuex store in browser to determine theme
     */
    themeUpdate () {
      if (this.$store.state.theme !== null) {
        
          this.$vuetify.theme = themes.telekomTheme
        
      }
    }
  },
  mounted () {
    /**
     * Check if theme corresponds to user when page is mounted
     */
    this.themeUpdate()
  },
  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback)
    })
    window.getApp = this
  },
  beforeUpdate () {
    this.themeUpdate()
  }
}
</script>
<style lang="stylus" scoped>
  .setting-fab
    top:50%!important;
    right:0;
    border-radius:0
  .page-wrapper
    min-height:calc(100vh - 64px - 50px - 81px );

</style>